<template lang="pug">
    .animation(ref='animation')
        .pocket(ref='pocket')
            img(src='../../assets/img/animations/pocket.jpg')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('middle-bottom', 'middle-middle');
        },
        createTimeline() {
            this.timeline = gsap.timeline();
            this.timeline.set(this.$refs.pocket, {x: '100%'}).fromTo(this.$refs.pocket, {x: '100%'}, {duration: 3, x: '0'}, 0);
        }
    }
};
</script>
<style lang="scss" scoped>
.animation {
    overflow: hidden;
}
.pocket {
    img {
        display: block;
        margin: 0 auto;
    }
}
</style>
